import { lazy } from "react";

// Authentication Components
export const ResetPassword = lazy(
  () => import("components/authentication/ResetPassword")
);
export const ForgotPassword = lazy(
  () => import("components/authentication/ForgotPassword")
);
export const ThankYouPage = lazy(
  () => import("components/authentication/ThankYou")
);
export const StyleGuide = lazy(() => import("style-guide/style_guide"));

// Dashboard Components
export const Home = lazy(() => import("components/dashboard/home/Home"));
export const Dashboard = lazy(
  () => import("components/dashboard/dashboard/index")
);
export const RFPPage = lazy(() => import("components/dashboard/rfp-page/RFPPage"));
export const GenerateRFPContainer = lazy(
  () => import("components/dashboard/generate-rfp/index")
);

// HR Module Components
export const AnalyzeJobFlow = lazy(() => import("modules/hr/pages/analyze"));
export const OpenApplicationsPage = lazy(
  () => import("modules/hr/pages/applications/open")
);
export const AnalysisPage = lazy(
  () => import("modules/hr/pages/analysis/index")
);

// RFP/Intake Components
export const BuildFromScratch = lazy(
  () => import("components/intake/buildScratch")
);
export const RfpDefined = lazy(() => import("components/intake/rfp_defined"));

// Summary/Report Components
export const MarketingAutomation = lazy(
  () => import("components/summary/MarketingAutomation")
);
export const GenerateReport = lazy(
  () => import("components/summary/CreateReport")
);

// Payment Components
export const CheckoutPage = lazy(
  () => import("components/payment/CheckoutPage")
);

//Analysed Applications
export const AnalysedApplicationsPage = lazy(
  () => import("modules/hr/pages/applications/analysed")
);

